import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class Validate {

  constructor() {

  }

  public static password(ctrl:AbstractControl) : ValidationErrors | null {
    let rgxNum = /[0-9]+/;
    let rgxLow = /[a-z]+/;
    let rgxUpp = /[A-Z]+/;
    let rgxSpc = /[\W|_]+/;
    
    let v = ctrl.value;     


    let res = null;
    
    if( !rgxNum.test(v) )
    { 
      res = (res || {});
      res.numericChar = true;
      res.pwdFormat = true;
    }

    if( !rgxLow.test(v) )
    { 
      res = (res || {});
      res.lowerChar = true;
      res.pwdFormat = true; 
    }

    if( !rgxUpp.test(v) )
    { 
      res = (res || {});
      res.upperChar  = true;
      res.pwdFormat = true; 
    }

    if( !rgxSpc.test(v) )
    { 
      res = (res || {});
      res.specialChar = true;
      res.pwdFormat = true; 
    }


    return res;

  }

  public static validaCNPJ(controle: AbstractControl) : ValidationErrors | null {
    const cnpj = controle.value.toString().replace(/[^\d]+/g,'');
    const invalids = [
      '00000000000000',
      '11111111111111',
      '22222222222222',
      '33333333333333',
      '44444444444444',
      '55555555555555',
      '66666666666666',
      '77777777777777',
      '88888888888888',
      '99999999999999'
    ];

    let valido = (cnpj != null) && (cnpj != '') && (cnpj.length == 14) && invalids.indexOf(cnpj) < 0;
    
    if(valido)
    {
      // Valida DVs
      let tamanho = cnpj.length - 2
      let numeros = cnpj.substring(0,tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i:number = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
              pos = 9;
      }

      let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      
      if (resultado != digitos.charAt(0))
        valido = false;
          
      tamanho = tamanho + 1;
      numeros = cnpj.substring(0,tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i:number = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
              pos = 9;
      }

      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      valido = valido && (resultado == digitos.charAt(1));
    }
    
    return valido ? null : { cnpjInvalido: true }
}

  public static ValidaCpf = (controle: AbstractControl) : ValidationErrors | null => {
    let aux = controle.value.toString().replace(/[^\d]+/g,'');
    const cpf = (aux.length == 10) ? '0' + aux : aux;
    const invalids = [
      '00000000000',
      '11111111111',
      '22222222222',
      '33333333333',
      '44444444444',
      '55555555555',
      '66666666666',
      '77777777777',
      '88888888888',
      '99999999999'
    ];

    let valido: boolean =  (cpf != null) && (cpf != '') && (cpf.length == 11) && invalids.indexOf(cpf) < 0;
    
    let numero = 0;
    let caracter = '';
    const numeros = '0123456789';
    let j = 10;
    let somatorio = 0;
    let resto = 0;
    let digito1 = 0;
    let digito2 = 0;
    let cpfAux = '';

    cpfAux = cpf.substring(0, 9);

    for (let i = 0; i < 9; i++) {
      caracter = cpfAux.charAt(i);
      if (numeros.search(caracter) === -1) {
        valido = false;
      }
      numero = Number(caracter);
      somatorio = somatorio + (numero * j);
      j--;
    }
    resto = somatorio % 11;
    digito1 = 11 - resto;
    if (digito1 > 9) {
      digito1 = 0;
    }
    j = 11;
    somatorio = 0;
    cpfAux = cpfAux + digito1;
    for (let i = 0; i < 10; i++) {
      caracter = cpfAux.charAt(i);
      numero = Number(caracter);
      somatorio = somatorio + (numero * j);
      j--;
    }
    resto = somatorio % 11;
    digito2 = 11 - resto;
    if (digito2 > 9) {
      digito2 = 0;
    }
    cpfAux = cpfAux + digito2;
    valido = valido && (cpf == cpfAux);
    
    return valido ? null : { cpfInvalido: true };
  }

  public static ValidaCnpjCpfPorTipo = (tipo: any) : ValidatorFn => {
    return 
  }

  public static ValidaCpfCnpj = (controle: AbstractControl) : ValidationErrors | null=>
    {
      if(controle.value != null)
      {
        if(controle.value.toString().replace(/[^\d]+/g,'').length > 11)
        return Validate.validaCNPJ(controle);
      else
        return Validate.ValidaCpf(controle);
      }
      else
        return null;
      
    }
 

  public static validarSeTemCaractereEspecial = (controle: AbstractControl) => {
    const caracter = controle.value;
    const regex = /[^A-Za-z0-9]/;
    let valido: boolean;

    if (regex.test(caracter)) {
      valido = true;
    } else {
      valido = false;
    }

    if (valido) { return null; } 

    return { caracterInvalido: true };
  }

  public static validarSeTemLetraMaiuscula = (controle: AbstractControl) => {
    const maiuscula = controle.value;
    const regex = /[A-Z]/;
    let valido: boolean;

    if (regex.test(maiuscula)) {
      valido = true;
    } else {
      valido = false;
    }

    if (valido) { return null; } 

    return { maiusculaInvalida: true };
  }

  public static validarSeTemLetraMinuscula = (controle: AbstractControl) => {
    const minuscula = controle.value;
    const regex = /[a-z]/;
    let valido: boolean;

    if (regex.test(minuscula)) {
      valido = true;
    } else {
      valido = false;
    }

    if (valido) { return null; } 

    return { minusculaInvalida: true };
  }

  public static validarSeTemNumero = (controle: AbstractControl) => {
    const numero = controle.value;
    const regex = /[0-9]/;
    let valido: boolean;

    if (regex.test(numero)) {
      valido = true;
    } else {
      valido = false;
    }

    if (valido) { return null; } 

    return { numeroInvalida: true };
  }

  public static validarMensagemRequest = (err: any): string => {
    let message  = 'Não foi possivel realizar esta operação.';

    if (err.error.ExceptionType === 'TWCore.Util.TWCoreWarning'){
      message = err.error.ExceptionMessage ? err.error.ExceptionMessage : err.error.error_description;
    }

    return  message;
  }
  public static validarLoginRequest = (err: any): string => {
    let message  = 'CPF/E-mail incorretos, verifique os dados de acesso.';

    if (err.error.ExceptionType === 'TWCore.Util.TWCoreWarning'){
      message = err.error.ExceptionMessage ? err.error.ExceptionMessage : err.error.error_description;
    }

    return  message;
  }
  public static MinDate(): ValidatorFn {
    return (control: AbstractControl) => {
       if (control.value == null) return null
       
       let dateTeste = new Date(2019, 10, 1);
 
       if (control.value._d < dateTeste.valueOf()) {
          return { 
            minDate: true 
          }
       }
 
       return null
    }
 }

}
